import { Constants } from '../../dashboard-constants';
import { FilterDetails, FilterField, FilterType } from './types';

export const SURVEY_FILTER_TYPE: Record<string, FilterType> = {
  SINGLE_OPTION: 'single_option',
  MULTI_OPTION: 'multi_option',
  SEARCH: 'search',
};

export const SURVEY_FILTER_FIELDS: Record<string, FilterField> = {
  BILLING: 'billing',
  COUNTRY_CODE: 'countryCode',
  HEALTH_CHECK_ALERT: 'healthCheckAlert',
  HEALTH_CHECK_ALERT_LEVEL: 'healthCheckAlertLevel',
  PM: 'pm',
  BPM: 'bpm',
  RECONCILIATION: 'reconciliation',
  SCORE: 'score',
  TITLE: 'searchTitle',
  TEMPLATE: 'template',
  TRAFFIC_CHANNELS: 'tc',
};

export const SURVEY_TABLE_FIELD_TO_FILTER_MAP: Record<string, FilterDetails> =
  Object.freeze({
    [Constants.SURVEY_LISTING_TABLE_HEADERS.BILLING_NUMBER]: {
      field: SURVEY_FILTER_FIELDS.BILLING,
      type: SURVEY_FILTER_TYPE.SINGLE_OPTION,
      options: ['EMPTY', 'NOT EMPTY'],
    },
    [Constants.SURVEY_LISTING_TABLE_HEADERS.COUNTRY_CODE]: {
      field: SURVEY_FILTER_FIELDS.COUNTRY_CODE,
      type: SURVEY_FILTER_TYPE.MULTI_OPTION,
    },
    [Constants.SURVEY_LISTING_TABLE_HEADERS.HEALTH_CHECK]: {
      field: SURVEY_FILTER_FIELDS.HEALTH_CHECK_ALERT,
      type: SURVEY_FILTER_TYPE.MULTI_OPTION,
      options: Constants.HEALTH_CHECK.METRIC_OPTIONS,
    },
    healthCheckAlertLevel: {
      field: SURVEY_FILTER_FIELDS.HEALTH_CHECK_ALERT_LEVEL,
      type: SURVEY_FILTER_TYPE.MULTI_OPTION,
      options: Constants.HEALTH_CHECK.ALERT_OPTIONS,
    },
    [Constants.SURVEY_LISTING_TABLE_HEADERS.OPERATOR_PROJECT_MANAGER]: {
      field: SURVEY_FILTER_FIELDS.PM,
      type: SURVEY_FILTER_TYPE.SINGLE_OPTION,
      options: ['EMPTY', 'NOT EMPTY'],
    },
    [Constants.SURVEY_LISTING_TABLE_HEADERS.BUYER_PROJECT_MANAGER]: {
      field: SURVEY_FILTER_FIELDS.BPM,
      type: SURVEY_FILTER_TYPE.SINGLE_OPTION,
      options: ['EMPTY', 'NOT EMPTY'],
    },
    // Reconciliation key is different from the table header key
    [Constants.RECONCILIATION.KEY]: {
      field: SURVEY_FILTER_FIELDS.RECONCILIATION,
      type: SURVEY_FILTER_TYPE.MULTI_OPTION,
      options: [
        Constants.RECONCILIATION.TYPES.ACCEPT,
        Constants.RECONCILIATION.TYPES.REJECT,
        Constants.RECONCILIATION.TYPES.COMPLETE,
        Constants.RECONCILIATION.TYPES.NOT_RECONCILED,
      ],
    },
    scorePercentage: {
      field: SURVEY_FILTER_FIELDS.SCORE,
      type: SURVEY_FILTER_TYPE.MULTI_OPTION,
      options: ['GREEN', 'YELLOW', 'RED'],
    },
    [Constants.SURVEY_LISTING_TABLE_HEADERS.SURVEY_TITLE]: {
      field: SURVEY_FILTER_FIELDS.TITLE,
      type: SURVEY_FILTER_TYPE.SEARCH,
    },
    [Constants.SURVEY_LISTING_TABLE_HEADERS.TEMPLATE]: {
      field: SURVEY_FILTER_FIELDS.TEMPLATE,
      type: SURVEY_FILTER_TYPE.MULTI_OPTION,
    },
    [Constants.SURVEY_LISTING_TABLE_HEADERS.TRAFFIC_CHANNELS]: {
      field: SURVEY_FILTER_FIELDS.TRAFFIC_CHANNELS,
      type: SURVEY_FILTER_TYPE.SINGLE_OPTION,
      options: ['EXIST', 'NOT EXIST'],
    },
  });
